<template>
  <div class='list-box'>
    <template v-if="list.length">
      <div class="item-box" v-for="(item, index) in  list " :key="index" @click="viewDetail(item)">
        <div class="user_info_box">
          <div class="user_info">
            <img class="user_img"
                 :src="item.photo?item.photo:`https://hospital-runsheng.oss-cn-shenzhen.aliyuncs.com/runsheng-wx/avatar.png`"/>
            <div class="user_name">
              <div class="name">{{ item.userName }}</div>
              <div class="age">{{ item.payTime }}</div>
            </div>
          </div>
          <p class="order_status">{{ getOrderStatusText(item) }}</p>
        </div>
        <div class="product_info_box" v-if="item.preType==2">
          <div class="drug_info" v-for="val in item.items" :key="val.id">
            <div class="drug_name">{{ val.tradeName }}</div>
          </div>
        </div>
        <div class="box_packed_drug" v-if="item.preType==1">
          <div class="drug_info" v-for="val in item.items" :key="val.id">
            <div class="drug_name_sku">
              <div class="drug_name">{{ val.tradeName }}
                <span class="drug_sku">（{{ val.drugSpecifications }}）</span>
              </div>
            </div>
            <div class="drug_num_price">×{{ val.quantity }}</div>
          </div>
        </div>
        <p class="order_amount">订单金额 <span class="amount">￥{{ Number(item.orderMoney) }}</span></p>
        <p>用药人：{{ item.userMemberName }}</p>
        <p>归属工作室：{{ item.rootChannelName }}</p>
        <div class="button-box" v-if="[5,14,10,6,11].includes(item.status)">
          <van-button type="info" plain square size="small" @click.stop="viewLogic(item)" class="write-box">查看物流
          </van-button>
        </div>
      </div>
      <div class="pagination" v-if="page.total > page.pageSize" style="padding: 20px 0;">
        <van-pagination v-model="page.pageNum" :total-items="page.total" :items-per-page="page.pageSize"
                        @change="pageChange">
          <template #prev-text>
            <van-icon name="arrow-left"/>
          </template>
          <template #next-text>
            <van-icon name="arrow"/>
          </template>
          <template #page="{ text }">{{ text }}</template>
        </van-pagination>
      </div>
    </template>
    <van-empty description="暂无数据" v-else/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {getDrugOrderList} from "@/api/home";
import BigNumber from 'bignumber.js' // 浮点数运算插件

export default {
  name: 'drugorder-list',
  components: {},
  data() {
    return {
      list: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        userMemberName: '',
        total: 0,
      },
    }
  },
  methods: {
    getOrderStatusText(item) {
      let {status} = item
      let statusStr = ''
      if (status == 0) {
        statusStr = '待付款'
      } else if (status == 1) {
        statusStr = '已支付'
      } else if (status == 2) {
        statusStr = '已关闭'
      } else if (status == 3) {
        statusStr = '已关闭'
      } else if (status == 4) {
        statusStr = '待发货'
      } else if (status == 5) {
        statusStr = '待收货'
      } else if (status == 6) {
        statusStr = '已完成'
      } else if (status == 7) {
        statusStr = '已退货'
      } else if (status == 8) {
        statusStr = '已关闭'
      } else if (status == 9) {
        statusStr = '拼团中（活动）'
      } else if (status == 10) {
        statusStr = '已完成'
      } else if (status == 11) {
        statusStr = '已完成'
      } else if (status == 12) {
        statusStr = '面单已打印'
      } else if (status == 13) {
        statusStr = '待自取'
      } else if (status == 14) {
        statusStr = '待收货'
      } else if (status == -1) {
        statusStr = '待审核'
      } else {
        statusStr = '未知'
      }
      return statusStr
    },
    setPageParams(keyword) {
      this.page.pageNum = 1
      this.page.pageSize = 10
      this.page.userMemberName = keyword
      this.getPageList()
    },
    async getPageList() {
      try {
        const params = {
          ...this.page,
          userNo: this.$store.state.assistantNo,
          status: '',
          channelType: 0,
        }
        const {data: {list, total}} = await getDrugOrderList(params)
        list.forEach((item) => {
          item.orderMoney = Number(new BigNumber(Number(item.totalFee)).plus(Number(item.shippingFee) || 0).plus(Number(item.platformFriedFee) || 0).minus(Number(item.discount)))
        })
        this.list = list
        this.page.total = total
      } catch (error) {
        this.list = []
        console.log(error)
      }
    },
    // 查看物流
    viewLogic(item) {
      this.$router.push({
        path: '/inquiryInfo/logistics',
        query: {
          askNo: item.orderNo,
          shippingCompName: item.orderLogistics?.shippingCompName,
        }
      })
    },
    // 详情
    viewDetail(item) {
      this.$router.push({
        path: '/teamOrders/drugDetail/index',
        query: {
          orderNo: item.orderNo,
          orderStatus: item.status,
          shippingCompName: item.orderLogistics?.shippingCompName
        }
      })
    },
    pageChange(pageNum) {
      this.page.pageNum = pageNum
      this.getPageList()
    },

  },
  computed: {
    ...mapGetters(['getLoginRole']),
  },
  watch: {},
  created() {
    this.getPageList()
  },
  activated() {
    this.getPageList()
  }
}
</script>
<style lang='scss' scoped>
.list-box {

  .item-box {
    background: #fff;
    border-radius: 0 0 4px 4px;
    padding: 15px;

    & + .item-box {
      margin-top: 15px;
    }

    .user_info_box {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .user_info {
        display: flex;

        .user_img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .user_name {
          margin-left: 8px;

          .name {
          }

          .age {
            color: #6d6d6e;
            margin-top: 4px;
          }
        }

      }

      .order_status {
      }
    }

    .product_info_box {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin-top: 20px;
      border: 0.5px solid #E4E6E6;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 16px;
      row-gap: 18px;
      column-gap: 66px;


      .drug_info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;


        .drug_name {
          font-weight: 400;
          font-size: 15px;
          color: #1B2120;

        }

        .drug_weight {
          font-weight: 400;
          font-size: 15px;
          color: #5C5E5E;
        }
      }

    }

    .box_packed_drug {
      margin-top: 20px;
      display: grid;
      grid-template-columns: 1fr;
      row-gap: 18px;
      border: 0.5px solid #E4E6E6;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 16px;

      .drug_info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .drug_name_sku {
          display: flex;
          flex-direction: row;
          font-weight: 400;
          font-size: 15px;
          color: #1B2120;
          word-break: break-all;
          max-width: 219px;

          .drug_name {
          }

          .drug_sku {
            color: #5C5E5E;
          }
        }

        .drug_num_price {
          font-weight: 400;
          font-size: 14px;
          color: #5C5E5E;
        }
      }

    }

    .order_amount {
      text-align: right;

      .amount {
        color: #dc0e0e;
      }
    }

    .button-box {
      display: flex;
      margin-top: 10px;
      justify-content: flex-end;

      .write-box {
        margin-left: 12px;
        border-radius: 8px;
        height: 30px;

        &.van-button--plain {
          background: #f5f5f5;
        }
      }
    }
  }
}
</style>